import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBaseUrl } from "../services/apiClient";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    fetch(`${getBaseUrl()}/users/sign_in`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: {
          email,
          password,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Login failed");

        // Lấy token từ header Authorization
        const token = response.headers.get("Authorization")?.split(" ")?.[1];
        if (!token) throw new Error("Token not found in response");

        localStorage.setItem("token", token); // Lưu token vào localStorage
        return response.json(); // Trả về thông tin user (tùy chọn)
      })
      .then((data) => {
        console.log("User info:", data.user);
        localStorage.setItem("user", JSON.stringify(data.user)); // Lưu thông tin user vào localStorage
        localStorage.setItem("isAdmin", data.is_super_admin); // Assuming isAdmin is a boolean in the user object
        navigate("/"); // Chuyển hướng về trang chủ
      })
      .catch((error) => console.error(error));
  };

  return (
    <div>
      { console.log("ENV: ", process.env.REACT_APP_API_BASE_URL) }
      
      <h1>Login</h1>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginPage;